import { render, staticRenderFns } from "./ModalCreatePin.vue?vue&type=template&id=39bdd054&"
import script from "./ModalCreatePin.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports